import getAnalytics from 'Modules/analytics';
import type { SearchRequest } from 'Modules/serverApi/types';
import isTruthy from 'Utils/isTruthy';

export function generateSearchId(request?: SearchRequest): string {
  if (!request) {
    return '';
  }

  const {
    query = '',
    hiddenQuery = '',
    filterQuery = '',
    catalog = '',
    sort = '',
    mode = '',
    variantsMode = '',
    selection = [],
  } = request;

  const params = {
    query,
    hiddenQuery,
    filterQuery,
    catalog,
    sort,
    mode,
    variantsMode,
    selection: normalizeSelection(selection),
  };

  const { sessionId } = getAnalytics();
  const paramsString = `${JSON.stringify(params, Object.keys(params).sort())}_${sessionId}`;

  return hashString(paramsString);
}

function hashString(str: string): string {
  let hash = 5381;

  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }

  return (hash >>> 0).toString(36);
}

function normalizeSelection(selection: SearchRequest['selection'] = []): string[] {
  if (!Array.isArray(selection)) {
    return [];
  }

  return selection
    .map((item) => (item?.field && item?.term ? `${item.field}|${item.term}` : null))
    .filter(isTruthy)
    .sort();
}
